// index.js
import React, { useState, useEffect, useRef } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import GroupTariffs from './GroupTarifs';
import { getSpecializations, getAcademicYears, getDisabilities } from './actions';
import { addNewGroup, deleteGroup, editGroup, archiveGroup } from '../../actions'
import { dictionary_default } from './data';
import { employeeAPI } from '../Employee/actions';

import { getGroupsDictionary } from '../../../../../services/apiClient';
import apiClient from '../../../../../services/apiClient';
import './group-modal.css';


const presets = {
  disabled: {
    sa: [],
    sa_kg: []
  }
};

const validationSchema = {
  number: {
    required: true,
    pattern: /^[A-Za-z0-9\s\(\)№.-]+$/,
    message: 'Номер групи може містити тільки літери, цифри та дефіс'
  },
  name: {
    required: true,
    pattern: /^[A-Za-zА-Яа-яЄєІіЇїҐґ0-9\s\-.,()'"]+$/,
    message: 'Назва групи містить недопустимі символи'
  },
  language: {
    required: true
  },
  address: {
    pattern: /^[A-Za-zА-Яа-яЄєІіЇїҐґ0-9\s\-.,()_'"/]+$/,
    message: 'Адреса містить недопустимі символи'
  },
  workStart: {
    pattern: /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/,
    message: 'Формат часу: гг:хх (наприклад, 07:00)'
  },
  workEnd: {
    pattern: /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/,
    message: 'Формат часу: гг:хх (наприклад, 19:00)'
  },
  capacity: {
    fullDay: {
      actual: { pattern: /^\d*$/, message: 'Може містити тільки цифри' },
      planned: { pattern: /^\d*$/, message: 'Може містити тільки цифри' }
    },
    shortStay: {
      actual: { pattern: /^\d*$/, message: 'Може містити тільки цифри' },
      planned: { pattern: /^\d*$/, message: 'Може містити тільки цифри' }
    },
    inclusiveFullDay: {
      actual: { pattern: /^\d*$/, message: 'Може містити тільки цифри' },
      planned: { pattern: /^\d*$/, message: 'Може містити тільки цифри' }
    },
    inclusiveShortStay: {
      actual: { pattern: /^\d*$/, message: 'Може містити тільки цифри' },
      planned: { pattern: /^\d*$/, message: 'Може містити тільки цифри' }
    }
  },
  // Додаємо перевірку для тарифів
  price: {
    required: true,
    validate: (price) => {
      if (!price || price.length === 0) {
        return 'Необхідно додати хоча б один тариф харчування';
      }
      
      // Перевіряємо, чи всі обов'язкові поля заповнені
      const invalidTariffs = price.filter(tariff => 
        !tariff.averageForDay || 
        !tariff.dateFrom || 
        !tariff.ageLimit || 
        !tariff.typeKitchen
      );
      
      if (invalidTariffs.length > 0) {
        return 'Всі тарифи повинні мати заповнені обов\'язкові поля (тариф, дата початку, вікова категорія, тип харчування)';
      }
      
      return '';
    }
  },
  period: {
    required: true,
    message: 'Навчальний рік обов\'язковий для вибору'
  }
};




const PlanedAmountHistory = ({ history }) => {
  const [isExpanded, setIsExpanded] = useState(false);


  if (!history || history.length === 0) {
    return null;
  }

  const getTypePlaceLabel = (type) => {
    const labels = {
      'sleepingPlaces': 'Спальних місць (повного дня)',
      'withoutBeds': 'Короткотривалого перебування', 
      'inclusive': 'Інклюзивна, повного дня',
      'inclusiveShort': 'Інклюзивна, короткотривалого перебування'
    };
    return labels[type] || type;
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('uk-UA', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="section">
      <div 
        className="history-header"
        onClick={() => setIsExpanded(!isExpanded)}
        style={{ cursor: 'pointer', userSelect: 'none' }}
      >
        <h6 className="d-flex align-items-center justify-content-between mb-0">
          <span>Історія змін планової кількості місць</span>
          <i 
            className={`fa-solid ${isExpanded ? 'fa-chevron-up' : 'fa-chevron-down'}`}
            style={{ transition: 'transform 0.2s' }}
          ></i>
        </h6>
      </div>
      
      {isExpanded && (
        <div className="history-content mt-3">
          <div className="table-bordered-wrap">
            <table className="table history-table mb-0">
              <thead>
                <tr>
                  <th style={{ width: '40%' }}>Тип місця</th>
                  <th style={{ width: '20%' }}>Кількість місць</th>
                  <th style={{ width: '40%' }}>Дата зміни</th>
                </tr>
              </thead>
              <tbody>
                {history.map((item) => (
                  <tr key={item._id}>
                    <td>{getTypePlaceLabel(item.typePlace)}</td>
                    <td>{item.value}</td>
                    <td>{formatDate(item.dateSet)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

const GroupModal = ({ show, onHide, groupData, isEditing = false, isNew = false, kg_id, group_id, mode = "edit", isAdmin = false }) => {
  // Начальные данные по умолчанию
   const getDefaultFormData = () => ({
    number: '',
    name: '',
    period: '',
    academicYearData: null,
    type: 1 || '',
    specifics: dictionary_default.specificsGroup[0] || '',
    specialization: 'без спеціалізації',
    language: 'Українська',
    educators: '',
    nutrition: '3 разове',
    address: '',
    internationalAgreement: false,
    workMode: 'Повний день',
    workStart: '',
    workEnd: '',
    capacity: {
      fullDay: { actual: '', planned: '' },
      shortStay: { actual: '', planned: '' },
      inclusiveFullDay: { actual: '', planned: '' },
      inclusiveShortStay: { actual: '', planned: '' }
    },
    price: [],
    disabilitiesType: ''
  });

  const [formData, setFormData] = useState(getDefaultFormData());
  const [kitchenData, setKitchenData] = useState({});
  const [disabilitiesList, setDisabilitiesList] = useState([]);
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [academicYears, setAcademicYears] = useState([]);
  const [isLoadingAcademicYears, setIsLoadingAcademicYears] = useState(false);
  const [dictGroups, setDictGroups] = useState([]);
  // Список активних працівників садочка — для вибору вихователів групи.
  const [employeesList, setEmployeesList] = useState([]);
  const [employeesLoading, setEmployeesLoading] = useState(false);
  // Всі групи садочка (з дітьми/резервом) — потрібно для перевірки
  // "чи можна видалити/архівувати групу" за тим самим алгоритмом, що й на
  // бекенді (isAllChildrenLeftOrTransferredToNextPeriodGroup). У formData
  // немає children/reservedPlaces, тому вантажимо окремо.
  const [allGroups, setAllGroups] = useState([]);

  

  const isLoadingRef = useRef(false);
  const isViewMode = mode === "view";


  const getCurPeriod = ()=>{
    const [yy,mm] = new Date().toISOString().split("-").slice(0,2).map(e=>+e);

    return mm > 8 ? yy : yy -1;

  }

  // Блокуємо архівування групи до 5 вересня (щороку) — щоб на початку
  // нового навчального року випадково не відправили в архів групу, яка
  // насправді ще діюча.
  const isArchivingBlockedBySeason = () => {
    const now = new Date();
    const sept5ThisYear = new Date(now.getFullYear(), 8, 5); // місяці з 0: 8 = вересень
    return now < sept5ThisYear;
  };

  // Точна копія бекенд-перевірки kindergartensModel.
  // isAllChildrenLeftOrTransferredToNextPeriodGroup() — щоб блокувати
  // кнопки "Видалити групу"/"Архівувати групу" ще ДО спроби запиту, а не
  // лише показувати помилку від бекенда постфактум.
  const canArchiveOrDeleteGroup = () => {
    // Дані ще не завантажені (або немає group_id — нова група) — не
    // блокуємо прев'ясно. Бекенд все одно перевірить це остаточно.
    if (!group_id || allGroups.length === 0) return true;

    const currentGroupRaw = allGroups.find(g => g._id === group_id);
    if (!currentGroupRaw) return true;

    const reservedPlacesExists = (currentGroupRaw.reservedPlaces || []).length > 0;
    if (reservedPlacesExists) return false;

    const groupPeriodStartYear = currentGroupRaw.periodStartYear;
    const groupChildren = currentGroupRaw.children || [];

    const nextPeriodGroupsChildren = allGroups
      .filter(g => g.number !== currentGroupRaw.number && g.periodStartYear === groupPeriodStartYear + 1)
      .reduce((acc, g) => acc.concat(g.children || []), []);

    const groupChildrenWhichNotLeftOrTransferred = groupChildren.filter(child =>
      typeof child.dateTo === 'undefined' &&
      nextPeriodGroupsChildren.every(nextChild => nextChild.childId !== child.childId)
    );

    return groupChildrenWhichNotLeftOrTransferred.length === 0;
  };

  const isYearAvailableForCreation = (academicYear) => {
    if (!academicYear || !academicYear.groupFormationStart) return false;
    
    const formationStart = new Date(academicYear.groupFormationStart);
    const now = new Date();
    
    // Год доступен если текущая дата >= даты начала формирования групп
    return now >= formationStart;
  };

  // Функция для получения текущего доступного года
  const getCurrentAvailableYear = () => {
    const availableYears = academicYears.filter(isYearAvailableForCreation);
    
    // Сортируем по году в убывающем порядке (самый новый первый)
    availableYears.sort((a, b) => parseInt(b.year) - parseInt(a.year));
    
    return availableYears.length > 0 ? availableYears[0] : null;
  };

  useEffect(()=>{
    const api = async()=>{
       const data = await getGroupsDictionary();
       setDictGroups(data);
    }

    api();
  },[]);

  useEffect(() => {
    if (!show || !kg_id || !isEditing) return;
    const loadAllGroups = async () => {
      try {
        const response = await apiClient.get(`kindergartens/${kg_id}`);
        const kg = response && response.data && response.data[0];
        setAllGroups((kg && kg.groups) || []);
      } catch (error) {
        console.error('Помилка завантаження груп садочка (для перевірки видалення/архівації):', error);
        setAllGroups([]);
      }
    };
    loadAllGroups();
  }, [show, kg_id, isEditing]);

  useEffect(() => {
    if (!show || !kg_id) return;
    const loadEmployees = async () => {
      setEmployeesLoading(true);
      try {
        const list = await employeeAPI.getActiveEmployees(kg_id);
        setEmployeesList(list || []);
      } catch (error) {
        console.error('Помилка завантаження списку працівників:', error);
        setEmployeesList([]);
      } finally {
        setEmployeesLoading(false);
      }
    };
    loadEmployees();
  }, [show, kg_id]);

  useEffect(() => {
    async function loadAcademicYears() {
      if (academicYears.length === 0 && !isLoadingAcademicYears) {
        setIsLoadingAcademicYears(true);
        const years = await getAcademicYears();
        setAcademicYears(years);
        setIsLoadingAcademicYears(false);
        
        // Для новой группы устанавливаем текущий доступный год по умолчанию
        if (isNew && years.length > 0) {
          const currentYear = getCurrentAvailableYear();
          if (currentYear) {
            setFormData(prev => ({
              ...prev,
              period: currentYear.value,
              academicYearData: currentYear
            }));
          }
        }
      }
    }

    loadAcademicYears();
  }, [isNew]);


   const handlePeriodChange = (yearId) => {
    if (isViewMode) return;
    
    const selectedYear = academicYears.find(year => year.value === yearId);
    
    setFormData(prev => ({
      ...prev,
      period: yearId,
      academicYearData: selectedYear || null
    }));
  };

  // Добавим валидацию для периода
  const validatePeriod = () => {
    if (!formData.period) {
      return 'Навчальний рік обов\'язковий для вибору';
    }
    
    const selectedYear = academicYears.find(year => year.value === formData.period);
    if (selectedYear && !isYearAvailableForCreation(selectedYear)) {
      return 'Обраний навчальний рік недоступний для створення груп';
    }
    
    return '';
  };

  // Валидация поля
  const validateField = (field, value, schema = validationSchema) => {
    const fieldSchema = schema[field];
    if (!fieldSchema) return '';

    if (fieldSchema.required) {
      if (field === 'price') {
        // Спеціальна перевірка для тарифів
        const error = fieldSchema.validate ? fieldSchema.validate(value) : '';
        if (error) return error;
      } else if (!value || (typeof value === 'string' && value.trim() === '') || 
                (Array.isArray(value) && value.length === 0)) {
        return 'Це поле обов\'язкове для заповнення';
      }
    }

    if (fieldSchema.pattern && value && !fieldSchema.pattern.test(value.toString())) {
      return fieldSchema.message;
    }

    if (typeof fieldSchema === 'object' && !fieldSchema.pattern && !fieldSchema.validate) {
      const nestedErrors = {};
      Object.keys(fieldSchema).forEach(key => {
        const error = validateField(key, value?.[key], fieldSchema);
        if (error) nestedErrors[key] = error;
      });
      return Object.keys(nestedErrors).length > 0 ? nestedErrors : '';
    }

    return '';
  };
  // Валидация всей формы
const validateForm = () => {
    const newErrors = {};

    Object.keys(validationSchema).forEach(field => {
      // Номер групи валідуємо тільки при СТВОРЕННІ нової групи.
      // Частину груп створювали ще в старій системі з іншими правилами
      // формату номера — редагувати такі групи (окрім самого номера,
      // який і так недоступний для зміни, див. disabled={isEditing})
      // валідація номера не повинна блокувати.
      if (field === 'number' && isEditing) return;

      const error = validateField(field, formData[field]);
      if (error) newErrors[field] = error;
    });

    // Добавляем валидацию периода
    const periodError = validatePeriod();
    if (periodError) {
      newErrors.period = periodError;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (field, value) => {
    if (isViewMode) return;
    
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));

    if (touched[field]) {
      const error = validateField(field, value);
      setErrors(prev => ({
        ...prev,
        [field]: error
      }));
    }
  };

  const handleCapacityChange = (type, field, value) => {
    if (isViewMode) return;
    
    setFormData(prev => ({
      ...prev,
      capacity: {
        ...prev.capacity,
        [type]: {
          ...prev.capacity[type],
          [field]: value
        }
      }
    }));

    const capacityPath = `capacity.${type}.${field}`;
    if (touched[capacityPath]) {
      const error = validateField(field, value, validationSchema.capacity?.[type]);
      setErrors(prev => ({
        ...prev,
        [capacityPath]: error
      }));
    }
  };

  const handleBlur = (field) => {
    if (isViewMode) return;
    
    setTouched(prev => ({
      ...prev,
      [field]: true
    }));

    let error = '';
    
    if (field === 'period') {
      error = validatePeriod();
    } else {
      error = validateField(field, formData[field]);
    }
    
    setErrors(prev => ({
      ...prev,
      [field]: error
    }));
  };

  const handleCapacityBlur = (type, field) => {
    if (isViewMode) return;
    
    const path = `capacity.${type}.${field}`;
    setTouched(prev => ({
      ...prev,
      [path]: true
    }));

    const error = validateField(field, formData.capacity?.[type]?.[field], validationSchema.capacity?.[type]);
    setErrors(prev => ({
      ...prev,
      [path]: error
    }));
  };

  

  useEffect(() => {
    if (!isNew && groupData) {
      const mergedData = {
        ...getDefaultFormData(),
        ...groupData,
        capacity: {
          ...getDefaultFormData().capacity,
          ...groupData.capacity
        },
        planedAmountHistory: groupData.planedAmountHistory || []
      };

      if (!mergedData.type && dictGroups[0]?.number) {
        mergedData.type = dictGroups[0].number;
      }
      
      if (!mergedData.specifics) {
        mergedData.specifics = dictionary_default.specificsGroup[0];
      }


      const disAbL = getDisabilities();


      if(disAbL) setDisabilitiesList(disAbL);


      setFormData(mergedData);
    } else {
      setFormData(getDefaultFormData());
    }
    setErrors({});
    setTouched({});
  }, [groupData, isNew, show]);

  const handleSubmit = async () => {
    if (isViewMode || isLoadingRef.current) return;


    const allTouched = {};
    Object.keys(validationSchema).forEach(field => {
      allTouched[field] = true;
    });
    setTouched(allTouched);

    // Додаткова перевірка для нової групи - обов'язковість тарифів
    if (!isEditing && (!formData.price || formData.price.length === 0)) {
      setErrors(prev => ({
        ...prev,
        price: 'Необхідно додати хоча б один тариф харчування для нової групи'
      }));
      return;
    }

    if (!validateForm()) {
      return;
    }

    isLoadingRef.current = true;
    const result = isEditing ? await editGroup(kg_id, group_id, formData) : await addNewGroup(formData, kg_id);
    isLoadingRef.current = false;
    alert('Дані успішно збережені');
    onHide('need_update');
  };

  const handleTariffChange = (tariffData, editingTariffId = null) => {
    if (isViewMode) return;
    
    setFormData(prev => {
      const currentPrices = [...prev.price];
      
      if (editingTariffId) {
        const updatedPrices = currentPrices.map(tariff => 
          (tariff._id === editingTariffId || tariff.id === editingTariffId) 
            ? { ...tariff, ...tariffData }
            : tariff
        );
        return { ...prev, price: updatedPrices };
      } else {
        const newTariff = {
          ...tariffData,
          _id: `temp-${Date.now()}`
        };
        return { ...prev, price: [...currentPrices, newTariff] };
      }
    });

    // Очищаємо помилку тарифів при додаванні нового тарифу
    if (errors.price) {
      setErrors(prev => ({
        ...prev,
        price: ''
      }));
    }
  };

  const handleTariffDelete = (tariffId) => {
    if (isViewMode) return;
    
    setFormData(prev => ({
      ...prev,
      price: prev.price.filter(tariff => 
        tariff._id !== tariffId && tariff.id !== tariffId
      )
    }));

    // Перевіряємо, чи залишилися тарифи після видалення
    setFormData(prev => {
      const hasTariffs = prev.price && prev.price.length > 0;
      if (!hasTariffs && !isEditing) {
        setErrors(prevErrors => ({
          ...prevErrors,
          price: 'Необхідно додати хоча б один тариф харчування для нової групи'
        }));
      }
      return prev;
    });
  };

  const getError = (path) => {
    const keys = path.split('.');
    let current = errors;
    for (const key of keys) {
      if (current && current[key]) {
        current = current[key];
      } else {
        return '';
      }
    }
    return typeof current === 'string' ? current : '';
  };

  const removeGroup = async (e)=>{
    if (isViewMode) return;
    if (!canArchiveOrDeleteGroup()) return;
    
    e.preventDefault();
    if (isLoadingRef.current) return;
    isLoadingRef.current = true;
    try {
      await deleteGroup(kg_id, group_id);
      alert('Групу видалено (або, якщо в ній залишались діти чи резерв, — відправлено до архіву).');
      onHide('need_update');
    } catch (error) {
      // Раніше результат взагалі не перевірявся і модалка завжди закривалась
      // так, ніби видалення пройшло успішно — навіть якщо бекенд повертав
      // isNotAllChildrenLeftOrTransferredError (група не порожня, і в ній є
      // діти, які ще не вибули/не переведені).
      alert(error?.message || 'Не вдалося видалити групу.');
    } finally {
      isLoadingRef.current = false;
    }
  }

  const _archiveGroup = async (e)=>{
    if (isViewMode) return;
    if (isArchivingBlockedBySeason()) return;
    if (!canArchiveOrDeleteGroup()) return;
    
    e.preventDefault();
    if (isLoadingRef.current) return;
    isLoadingRef.current = true;
    try {
      await archiveGroup(kg_id, group_id);
      alert('Група відправлена до архіву');
      onHide('need_update');
    } catch (error) {
      // Архівація заблокована на бекенді (напр. код 4099 — в групі ще є
      // діти, які не вибули і не переведені до групи наступного періоду).
      // Раніше тут завжди показувалось "успіх" незалежно від результату.
      alert(error?.message || 'Не вдалося архівувати групу.');
    } finally {
      isLoadingRef.current = false;
    }
  }


  const periodYears =  dictionary_default.periods_start_year.findIndex(p=>p == formData.period) > -1 ?  dictionary_default.periods_start_year : [formData.period];

  const getModalTitle = () => {
    if (isViewMode) return 'Про групу';
    return isEditing ? 'Редагування групи' : 'Створення нової групи';
  };


  const _academicYears =academicYears.filter(year => isEditing || isYearAvailableForCreation(year));

  if(!_academicYears.map(y=>y.value).includes(formData.period)) _academicYears.push({value: formData.period, name: formData.period + '-' + (formData.period + 1)} );


  return (
    <Modal show={show} onHide={onHide} className="group-modal" size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>{getModalTitle()}</Modal.Title>
      </Modal.Header>
      
      <Modal.Body>
        {false && Object.keys(errors).length > 0 && (
          <Alert variant="warning" className="mb-3">
            Будь ласка, виправте помилки в формі
          </Alert>
        )}

        {/* Основная информация */}
        <div className="section">
          <div className="details-grid">
            <div className="field-row row align-items-center">
              <div className="col-md-3 field-label">Номер групи *</div>
              <div className="col-md-9">
                <input
                  type="text"
                  className={`form-control control-180 ${getError('number') ? 'is-invalid' : ''}`}
                  value={formData.number}
                  onChange={(e) => handleInputChange('number', e.target.value)}
                  onBlur={() => handleBlur('number')}
                  placeholder="Номер групи"
                  disabled={isEditing || isViewMode}
                />
                {getError('number') && (
                  <div className="invalid-feedback">{getError('number')}</div>
                )}
              </div>
            </div>

            <div className="field-row row align-items-center">
              <div className="col-md-3 field-label">Назва групи *</div>
              <div className="col-md-9">
                <input
                  type="text"
                  className={`form-control ${getError('name') ? 'is-invalid' : ''}`}
                  value={formData.name}
                  onChange={(e) => handleInputChange('name', e.target.value)}
                  onBlur={() => handleBlur('name')}
                  placeholder="Введіть назву групи"
                  disabled={isViewMode}
                />
                {getError('name') && (
                  <div className="invalid-feedback">{getError('name')}</div>
                )}
              </div>
            </div>

            <div className="field-row row align-items-center">
              <div className="col-md-3 field-label">Навчальний рік</div>
              <div className="col-md-9">
                {isLoadingAcademicYears ? (
                  <div className="text-muted">Завантаження навчальних років...</div>
                ) : (
                  <>
                    <select 
                      className={`form-select control-180 ${getError('period') ? 'is-invalid' : ''}`}
                      value={formData.period}
                      onChange={(e) => handlePeriodChange(e.target.value)}
                      onBlur={() => handleBlur('period')}
                      disabled={isEditing || isViewMode}
                    >
                      <option value="">Оберіть навчальний рік</option>
                      {_academicYears
                        .map((year) => (
                          <option 
                            value={year.value} 
                            key={year.value}
                            disabled={!isYearAvailableForCreation(year)}
                          >
                            {year.name} {!isYearAvailableForCreation(year) && '(недоступний)'}
                          </option>
                        ))
                      }
                    </select>
                    {getError('period') && (
                      <div className="invalid-feedback">{getError('period')}</div>
                    )}
                    {formData.academicYearData && (
                      <div className="form-text">
                        Дата початку формування груп: {new Date(formData.academicYearData.groupFormationStart).toLocaleDateString('uk-UA')}
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>

            <div className="field-row row align-items-center">
              <div className="col-md-3 field-label">Назва типу групи</div>
              <div className="col-md-9">
                <select 
                  className="form-select" 
                  value={formData.type || dictGroups[0].number}
                  onChange={(e) => handleInputChange('type', e.target.value)}
                  disabled={isAdmin ? false :  isEditing || isViewMode }
                >
                  {dictGroups.map((v, i) => (
                    <option value={dictGroups[i]?.number} key={`typeGroups_${i}`}>
                      {v.description}
                    </option>
                  ))} 
                </select>
              </div>
            </div>

            <div className="field-row row align-items-center">
              <div className="col-md-3 field-label">Вид групи</div>
              <div className="col-md-9">
                <select 
                  className="form-select" 
                  value={formData.specifics || dictionary_default.specificsGroup[0]}
                  onChange={(e) => {
                    const value = e.target.value;
                    handleInputChange('specifics', value);
                    if(value == dictionary_default.specificsGroup[0]) handleInputChange('specialization', '')
                  }}
                  disabled={isAdmin ? false :  isEditing || isViewMode}
                >
                  {dictionary_default.specificsGroup.map((v, i) => (
                    <option key={`specificsGroup_${i}`} value={v}>
                      {v}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="field-row row align-items-center">
              <div className="col-md-3 field-label">За типом труднощів</div>
              <div className="col-md-9">
                <select 
                  className="form-select" 
                  value={formData.disabilitiesType || ''}
                  onChange={(e) => handleInputChange('disabilitiesType', e.target.value)}
                  disabled={isAdmin ? false :  isEditing || isViewMode || formData.specifics == dictionary_default.specificsGroup[0]}
                >
                  <option value="">Оберіть тип труднощів</option>
                  {disabilitiesList?.map((r, i) => (
                    <option key={`specializations_${i}`} value={r._id}>
                      {r.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="field-row row align-items-center">
              <div className="col-md-3 field-label">Мова викладання *</div>
              <div className="col-md-9">
                <select 
                  className={`form-select ${getError('language') ? 'is-invalid' : ''}`}
                  value={formData.language}
                  onChange={(e) => handleInputChange('language', e.target.value)}
                  onBlur={() => handleBlur('language')}
                  disabled={isViewMode}
                >
                  <option value="Українська">Українська</option>
                  <option value="Англійська">Англійська</option>
                  <option value="Інша">Інша</option>
                </select>
                {getError('language') && (
                  <div className="invalid-feedback">{getError('language')}</div>
                )}
              </div>
            </div>

            <div className="field-row row align-items-start">
              <div className="col-md-3 field-label">Вихователі</div>
              <div className="col-md-9">
                {!isViewMode && (
                  <select
                    className="form-select mb-2"
                    value=""
                    disabled={employeesLoading}
                    onChange={(e) => {
                      const employeeId = e.target.value;
                      if (!employeeId) return;
                      const emp = employeesList.find(item => item._id === employeeId);
                      if (!emp) return;
                      if ((formData.educators || []).some(ed => ed.employeeId === employeeId)) return;
                      setFormData(prev => ({
                        ...prev,
                        educators: [...(prev.educators || []), {
                          employeeId,
                          firstName: emp.firstName,
                          lastName: emp.lastName
                        }]
                      }));
                    }}
                  >
                    <option value="">{employeesLoading ? 'Завантаження...' : 'Додати вихователя зі списку працівників...'}</option>
                    {employeesList
                      .filter(emp => !(formData.educators || []).some(ed => ed.employeeId === emp._id))
                      .map(emp => (
                        <option key={emp._id} value={emp._id}>
                          {[emp.lastName, emp.firstName].filter(Boolean).join(' ')}
                        </option>
                      ))}
                  </select>
                )}

                {(formData.educators || []).length === 0 ? (
                  <div className="text-muted small">Вихователів не обрано</div>
                ) : (
                  <div className="d-flex flex-wrap gap-2">
                    {(formData.educators || []).map((ed, idx) => (
                      <span
                        key={ed.employeeId || idx}
                        className="badge bg-light text-dark border d-flex align-items-center gap-1"
                        style={{ fontSize: 13, padding: '6px 10px', fontWeight: 400 }}
                      >
                        {[ed.lastName, ed.firstName].filter(Boolean).join(' ') || 'Без імені'}
                        {!isViewMode && (
                          <button
                            type="button"
                            className="btn-close"
                            style={{ fontSize: 8, marginLeft: 4 }}
                            aria-label="Прибрати"
                            onClick={() => setFormData(prev => ({
                              ...prev,
                              educators: (prev.educators || []).filter((_, i) => i !== idx)
                            }))}
                          />
                        )}
                      </span>
                    ))}
                  </div>
                )}
                {getError('educators') && (
                  <div className="text-danger small mt-1">{getError('educators')}</div>
                )}
              </div>
            </div>

            <div className="field-row row align-items-center">
              <div className="col-md-3 field-label">Харчування</div>
              <div className="col-md-9">
                <select 
                  className="form-select"
                  value={formData.nutrition}
                  onChange={(e) => handleInputChange('nutrition', e.target.value)}
                  disabled={isViewMode}
                >
                  <option value="3 разове">3 разове</option>
                  <option value="4 разове">4 разове</option>
                  <option value="5 разове">5 разове</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        {/* Тарифы */}
        <GroupTariffs 
          formData={formData} 
          onChange={handleTariffChange}
          onDelete={handleTariffDelete}
          mode={mode}
        />
        {/* Додаємо відображення помилки тарифів */}
        {errors.price && (
          <Alert variant="danger" className="mt-2">
            {errors.price}
          </Alert>
        )}

        {/* Адрес и договор */}
        <div className="section">
          <div className="details-grid">
            <div className="field-row row align-items-center">
              <label className="col-md-3 field-label" htmlFor="groupAddress">
                Адреса групи
              </label>
              <div className="col-md-9">
                <input
                  id="groupAddress"
                  type="text"
                  className={`form-control ${getError('address') ? 'is-invalid' : ''}`}
                  value={formData.address}
                  onChange={(e) => handleInputChange('address', e.target.value)}
                  onBlur={() => handleBlur('address')}
                  placeholder="Введіть адресу групи"
                  disabled={isViewMode}
                />
                {getError('address') && (
                  <div className="invalid-feedback">{getError('address')}</div>
                )}
              </div>
            </div>

            <div className="field-row row align-items-center">
              <label className="col-md-3 field-label" htmlFor="intl">
                Міжнародний договір
              </label>
              <div className="col-md-9">
                <div className="form-check m-0">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="intl"
                    checked={formData.internationalAgreement}
                    onChange={(e) => handleInputChange('internationalAgreement', e.target.checked)}
                    disabled={isViewMode}
                  />
                  <label className="form-check-label visually-hidden" htmlFor="intl">
                    Міжнародний договір
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Режим работы */}
        <div className="section">
          <h6 style={{ margin: '20px 0 20px 0' }}>Режим роботи</h6>
          <div className="row g-3">
            <div className="col-md-4">
              <label className="form-label">Режим роботи</label>
              <select 
                className="form-select"
                value={formData.workMode}
                onChange={(e) => handleInputChange('workMode', e.target.value)}
                disabled={isViewMode}
              >
                <option value="Повний день">Повний день</option>
                <option value="Короткотривале перебування">Короткотривале перебування</option>
                <option value="Група продовженого дня">Група продовженого дня</option>
              </select>
            </div>
            <div className="col-md-4">
              <label className="form-label">Початок роботи</label>
              <input
                type="text"
                className={`form-control ${getError('workStart') ? 'is-invalid' : ''}`}
                value={formData.workStart}
                onChange={(e) => handleInputChange('workStart', e.target.value)}
                onBlur={() => handleBlur('workStart')}
                placeholder="7:00"
                disabled={isViewMode}
              />
              {getError('workStart') && (
                <div className="invalid-feedback">{getError('workStart')}</div>
              )}
            </div>
            <div className="col-md-4">
              <label className="form-label">Завершення роботи</label>
              <input
                type="text"
                className={`form-control ${getError('workEnd') ? 'is-invalid' : ''}`}
                value={formData.workEnd}
                onChange={(e) => handleInputChange('workEnd', e.target.value)}
                onBlur={() => handleBlur('workEnd')}
                placeholder="19:00"
                disabled={isViewMode}
              />
              {getError('workEnd') && (
                <div className="invalid-feedback">{getError('workEnd')}</div>
              )}
            </div>
          </div>
        </div>

        {/* Количество мест */}
        <div className="section">
          <h6 style={{ margin: '20px 0 -20px 0' }}>Кількість місць</h6>
          <div className="capacity-grid">
            <div className="row g-3 align-items-center header-row">
              <div className="col-md-6"></div>
              <div className="col-md-3">
                <div className="col-label">Фактична</div>
              </div>
              <div className="col-md-3">
                <div className="col-label">Планова</div>
              </div>
            </div>

            {[
              { key: 'fullDay', label: 'Спальних місць (повного дня)' },
              { key: 'shortStay', label: 'Короткотривалого перебування' },
              { key: 'inclusiveFullDay', label: 'Інклюзивна, повного дня' },
              { key: 'inclusiveShortStay', label: 'Інклюзивна, короткотривалого перебування' }
            ].map((item) => (
              <div key={item.key} className="row g-3 align-items-center">
                <div className="col-md-6">
                  <label className="form-label">{item.label}</label>
                </div>
                <div className="col-md-3">
                  <input
                    type="number"
                    className={`form-control ${getError(`capacity.${item.key}.actual`) ? 'is-invalid' : ''}`}
                    value={formData.capacity?.[item.key]?.actual || ''}
                    onChange={(e) => handleCapacityChange(item.key, 'actual', e.target.value)}
                    onBlur={() => handleCapacityBlur(item.key, 'actual')}
                    placeholder="Фактична"
                    disabled={isViewMode}
                  />
                  {getError(`capacity.${item.key}.actual`) && (
                    <div className="invalid-feedback">{getError(`capacity.${item.key}.actual`)}</div>
                  )}
                </div>
                <div className="col-md-3">
                  <input
                    type="number"
                    className={`form-control ${getError(`capacity.${item.key}.planned`) ? 'is-invalid' : ''}`}
                    value={formData.capacity?.[item.key]?.planned || ''}
                    onChange={(e) => handleCapacityChange(item.key, 'planned', e.target.value)}
                    onBlur={() => handleCapacityBlur(item.key, 'planned')}
                    placeholder="Планова"
                    disabled={isViewMode}
                  />
                  {getError(`capacity.${item.key}.planned`) && (
                    <div className="invalid-feedback">{getError(`capacity.${item.key}.planned`)}</div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
        <PlanedAmountHistory history={formData.planedAmountHistory || []} />
      </Modal.Body>

      <Modal.Footer className="justify-content-between">
        {isEditing && !isViewMode && formData['period'] && (formData['period'] >= getCurPeriod()) && (
          canArchiveOrDeleteGroup() ? (
            <a href="#" className="btn-link-danger" onClick={removeGroup}>
              Видалити групу
            </a>
          ) : (
            <span
              className="btn-link-danger"
              style={{ opacity: 0.5, cursor: 'not-allowed' }}
              title="У групі є діти, які ще не вибули і не переведені до групи наступного періоду (або є зарезервовані місця) — видалення заблоковано."
            >
              Видалити групу
            </span>
          )
        )}
        {isEditing && !isViewMode && formData['period'] && (formData['period'] < getCurPeriod()) && (
          isArchivingBlockedBySeason() ? (
            <span
              className="btn-link-danger"
              style={{ opacity: 0.5, cursor: 'not-allowed' }}
              title="Архівування групи заблоковано до 5 вересня — щоб на початку нового навчального року випадково не відправили в архів діючу групу."
            >
              Архівувати групу
            </span>
          ) : !canArchiveOrDeleteGroup() ? (
            <span
              className="btn-link-danger"
              style={{ opacity: 0.5, cursor: 'not-allowed' }}
              title="У групі є діти, які ще не вибули і не переведені до групи наступного періоду (або є зарезервовані місця) — архівування заблоковано."
            >
              Архівувати групу
            </span>
          ) : (
            <a href="#" className="btn-link-danger" onClick={_archiveGroup}>
              Архівувати групу
            </a>
          )
        )}
        <div>
          <Button variant="secondary" onClick={onHide} className="me-2">
            {isViewMode ? 'Закрити' : 'Скасувати'}
          </Button>
          {!isViewMode && (
            <Button variant="primary" onClick={handleSubmit}>
              {isEditing ? 'Зберегти зміни' : 'Створити групу'}
            </Button>
          )}
        </div>
      </Modal.Footer>
    </Modal>
  );
};

GroupModal.defaultProps = {
  groupData: null,
  isEditing: false,
  mode: "edit"
};

export default GroupModal;